import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    successText: { type: String, default: "Copiado" },
    resetMs: { type: Number, default: 1800 }
  }

  copy(event) {
    event.preventDefault()
    const text = this.sourceText
    if (!text) return

    navigator.clipboard.writeText(text).then(() => this.flashSuccess())
  }

  get sourceText() {
    if (this.hasSourceTarget) return this.sourceTarget.innerText
    const code = this.element.querySelector("code")
    return code ? code.innerText : ""
  }

  flashSuccess() {
    if (!this.hasButtonTarget) return
    const btn = this.buttonTarget
    const original = btn.dataset.originalText ?? btn.textContent
    btn.dataset.originalText = original
    btn.textContent = this.successTextValue
    btn.classList.add("is-copied")
    clearTimeout(this._resetTimer)
    this._resetTimer = setTimeout(() => {
      btn.textContent = original
      btn.classList.remove("is-copied")
    }, this.resetMsValue)
  }
}
